import { render, staticRenderFns } from "./CourseSelect.vue?vue&type=template&id=3d7774a0&scoped=true&"
import script from "./CourseSelect.ts?vue&type=script&lang=ts&"
export * from "./CourseSelect.ts?vue&type=script&lang=ts&"
import style0 from "./CourseSelect.css?vue&type=style&index=0&id=3d7774a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7774a0",
  null
  
)

export default component.exports